<template>
  <div class="offset-container-holder">
    <NumericField :segment="{ value: 200 }" :type="'offset l'" :bgColor="'white'"  layout="row" elementColor="whitesmoke"/>
    <NumericField :segment="{ value: 100 }" :type="'spacing'" :bgColor="'whitesmoke'" layout="row"/>
    <NumericField :segment="{ value: 200 }" :type="'offset r'" :bgColor="'white'"  layout="row" elementColor="whitesmoke"/>
  </div>
</template>

<script>
import TopLeftMargin from '@/components/TopLeftMargin';
import ChartOverflow from '@/components/ChartOverflow';
import TopRightMargin from '@/components/TopRightMargin';
import { gsap } from 'gsap';
import { useInputStore } from '@/store/InputStore';
import NumericField from '@/components/nelson/NumericField.vue';

export default {
  name: 'OffsetContainer',
  data () {
    return {
      isExpanded: true
    };
  },
  components: {
    NumericField,
    TopLeftMargin,
    ChartOverflow,
    TopRightMargin 
  },
  methods: {
    handleExpand () {
      const inputStore = useInputStore();
      const spacingExpanded = inputStore.getSpacingExpanded;
      gsap.to(this.$refs.spacingArrow, {
        rotation: spacingExpanded ? 0 : -180,
        duration: .3
      });
      gsap.to(this.$refs.expandHolder, {
        height: spacingExpanded ? 0 : 110 + 'px',
        duration: .3,
        ease: 'power3.inOut'
      });
      inputStore.toggleSpacingExpanded();
    }
  }
};
</script>

<style scoped>
.offset-container-holder {
  display: flex;
  justify-content: space-between;
  padding-top: 3px;
  padding-bottom: 3px;
  border-top: 1px solid lightgray;
  border-bottom: 1px solid gray;
}
.chart-overflow {
  width: 80%;
  height: 40px;
}
.top-margin {
  text-align: center;
  width: 10%;
  min-width: 120px;
  height: 110px;
}
.spacing-arrow-holder {
  width: 10px;
  margin-right:10px;
  margin-top:-2px;
  cursor: pointer;
}
.spacing-expand-holder {
  display: flex;
  position: absolute;
  justify-content: space-between;
  width: 100%;
  height: 55px;
  border-top: 1px solid black;
  pointer-events: none;
}
.spacing-header {
  font-weight: 800;
  font-size: 70%;
  display: flex;
  margin-left: 10px;
  align-items: center;
}
.spacing-expand-header {
  width: 100%;
  display: flex;
}
.spacing-holder {
  width: 10%;
  min-width: 120px;
  display: flex;
  justify-content: space-between;
}
.offset-floating-container {
  width: 100%;
  position: absolute;
  background: rgba(255,255,255,.9);
}
</style>